import { AsiFilterService } from './asi-filter.service';
import { FilterObject } from "./filters/filter-object";
import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: 'asiFilter' })
export class AsiFilterPipe implements PipeTransform {

  constructor(private filterService : AsiFilterService){
  }

  transform(items: Array<any>, filters: Array<FilterObject<any>>) {
   return this.filterService.filterList(items, filters);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/components/filter/asi.filter.pipe.ts